import AuditTypes from '../types/AuditTypes';

const initialState = {
  isLoading: false,
  auditData: {},
  auditItemData: {},
  auditModuleData: [],
  auditUserData: []
};

// eslint-disable-next-line default-param-last
const audit = (state = initialState, action) => {
  switch (action.type) {
    case AuditTypes.GET_AUDIT_TRAIL_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case AuditTypes.GET_AUDIT_TRAIL_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        auditData: action.payload
      };
    case AuditTypes.GET_AUDIT_TRAIL_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        auditData: {}
      };

    case AuditTypes.GET_AUDIT_TRAIL_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case AuditTypes.GET_AUDIT_TRAIL_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        auditItemData: action.payload
      };
    case AuditTypes.GET_AUDIT_TRAIL_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        auditItemData: {}
      };
    case AuditTypes.GET_AUDIT_MODULE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case AuditTypes.GET_AUDIT_MODULE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        auditModuleData: action.payload
      };
    case AuditTypes.GET_AUDIT_MODULE_ERROR:
      return {
        ...state,
        isLoading: false,
        auditModuleData: []
      };

    case AuditTypes.GET_AUDIT_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case AuditTypes.GET_AUDIT_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        auditUserData: action.payload
      };
    case AuditTypes.GET_AUDIT_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        auditUserData: []
      };

    default:
      return state;
  }
};
export default audit;
